function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import * as jose from "jose";
function signJWT(object, secretPhrase) {
    return _signJWT.apply(this, arguments);
}
function _signJWT() {
    _signJWT = _async_to_generator(function(object, secretPhrase) {
        var expirationTime, headers, alg, secret, jwt;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    expirationTime = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : "12h", headers = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {};
                    alg = "HS256";
                    secret = new TextEncoder().encode(secretPhrase);
                    return [
                        4,
                        new jose.SignJWT(object).setProtectedHeader(_object_spread({
                            alg: alg
                        }, headers)).setExpirationTime(expirationTime).sign(secret)
                    ];
                case 1:
                    jwt = _state.sent();
                    return [
                        2,
                        jwt
                    ];
            }
        });
    });
    return _signJWT.apply(this, arguments);
}
function produceJWT(payload) {
    return new jose.UnsecuredJWT(payload).encode();
}
function decodeJWT(jwt) {
    return jose.decodeJwt(jwt);
}
function verifyJWT(jwt, secretPhrase) {
    return _verifyJWT.apply(this, arguments);
}
function _verifyJWT() {
    _verifyJWT = _async_to_generator(function(jwt, secretPhrase) {
        var alg, secret, verificationResult, error;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    alg = "HS256";
                    secret = new TextEncoder().encode(secretPhrase);
                    verificationResult = {
                        error: null,
                        isValid: false
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        jose.jwtVerify(jwt, secret, {
                            algorithms: [
                                alg
                            ]
                        })
                    ];
                case 2:
                    _state.sent();
                    verificationResult.isValid = true;
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    verificationResult.error = error;
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        verificationResult
                    ];
            }
        });
    });
    return _verifyJWT.apply(this, arguments);
}
export { signJWT, produceJWT, decodeJWT, verifyJWT };
